<template>
<!--
@TODO 
- добавление своего, ни именно числового, значения
-->
    <v-combobox
        v-model="model"
        :items="itemsToShow"
        v-bind="$attrs"
        v-on="$listeners"
        :filter="filter"
        :hide-no-data="!search"
        :search-input.sync="search"
        :disabled="disabled"
        @keypress="isNumber"
    >                                                
        <template v-slot:no-data>
            <v-list-item class="add-new-value" v-if="_.isFinite(Number(search))">
                <span class="subheading">Добавить</span>
                <v-chip color="green lighten-3" label small>{{ search }}{{ postfix }}</v-chip>
            </v-list-item>
            <v-list-item class="add-new-value" v-else>
                <v-chip color="red lighten-3" label small>Недопустимое значение {{ search }}</v-chip>
            </v-list-item>
        </template>
        <template v-slot:selection="{ attrs, item, parent, selected }">
            <v-chip
                v-bind="attrs"
                :color="getColor(item)"
                :dark="isDark(getColor(item))"
                :input-value="selected"
                label
                small
                :disabled="disabled"
            >
                <span class="pr-2">{{ item }}{{ postfix }}</span>
                <v-icon small @click="parent.selectItem(item)">$delete</v-icon>
            </v-chip>
        </template>
        <template v-slot:item="{ index, item }">
            <v-text-field
                v-if="isEditableItems && editing === item"
                v-model="editing"
                autofocus
                flat
                background-color="transparent"
                hide-details
                solo
                @keyup.enter="edit(index, item)"
            ></v-text-field>
            <v-chip
                v-else
                :color="getColor(item)"
                :dark="isDark(getColor(item))"
                label
                small
            >{{ item }}{{ postfix }}</v-chip>
            <v-spacer></v-spacer>
            <v-list-item-action @click.stop v-if="isEditableItems">
                <v-btn
                    icon
                    @click.stop.prevent="edit(index, item)"
                >
                    <v-icon>{{ editing !== item ? 'mdi-pencil' : 'mdi-check' }}</v-icon>
                </v-btn>
            </v-list-item-action>
        </template>
    </v-combobox>
</template>
<script>

export default {
    name: 'NumberRangeCombobox',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        items: {
            type: Array,
            default: () => [],
        },
        postfix: String,
        isEditableItems: Boolean,
        itemsColor: String,
        sorted: Boolean,
        disabled: Boolean,
    },
    data: () => ({
        editing: null,
        editingIndex: -1,
        search: null,
    }),
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', this._.filter(v, n => this._.isFinite(Number(n))));
            }
        },
        itemsToShow() {
            return this.sorted ? this._(this.items).map(v => Number(v)).sort((a, b) => a - b).value() : this.items;
        },
    },
    watch: {
        value: { 
            handler(val, prev) {
                if (!val || val.length === prev?.length) return;
                this.model = val.map(v => {
                    v = Number(v);
                    if (!isNaN(v) && Array.isArray(this.items) && !this.items.includes(v)) {
                        this.$emit('update:items', [...this.items, v]);
                    }
                    return v;
                });
            },
            deep: true,
        },
    },
    methods: {
        edit (index, item) {
            if (!this.editing) {
                this.editing = item;
                this.editingIndex = index;
            } else {
                this.editing = null;
                this.editingIndex = -1;
            }
        },
        filter (item, queryText, itemText) {
            if (item.header) {
                return false;
            }
            const hasValue = val => val != null ? val : '';
            const text = hasValue(itemText);
            const query = hasValue(queryText);
            return text.toString()
                .toLowerCase()
                .indexOf(query.toString().toLowerCase()) > -1;
        },
        // interpolate between two colors
        interpolateColor(start, end, fraction) {
            const r = Math.round(start.r + (end.r - start.r) * fraction);
            const g = Math.round(start.g + (end.g - start.g) * fraction);
            const b = Math.round(start.b + (end.b - start.b) * fraction);
            return `rgb(${r}, ${g}, ${b})`;
        },
        getColorFromValue(val) {
            const minValue = Math.min(...this.items);
            const maxValue = Math.max(...this.items);
            val = Math.max(minValue, Math.min(maxValue, val));
            const blue = { r: 0, g: 0, b: 255 };
            const white = { r: 245, g: 245, b: 245 };
            const red = { r: 255, g: 0, b: 0 };
            if (val < 0) {
                const fraction = (val - minValue) / (0 - minValue);
                return this.interpolateColor(blue, white, fraction);
            } else if (val > 0) {
                const fraction = val / maxValue;
                return this.interpolateColor(white, red, fraction);
            }
            return `rgb(${white.r},${white.g},${white.b})`;
        },
        isDark(color) {
            let r, g, b;
            // hex-формат
            if (color[0] === '#') {
                if (color.length === 4) {
                    r = parseInt(color[1] + color[1], 16);
                    g = parseInt(color[2] + color[2], 16);
                    b = parseInt(color[3] + color[3], 16);
                } else if (color.length === 7) {
                    r = parseInt(color.slice(1, 3), 16);
                    g = parseInt(color.slice(3, 5), 16);
                    b = parseInt(color.slice(5, 7), 16);
                }
            } else if (color.startsWith('rgb')) {
                // формат rgb
                const rgb = color.match(/\d+/g);
                r = parseInt(rgb[0], 10);
                g = parseInt(rgb[1], 10);
                b = parseInt(rgb[2], 10);
            }
            // Вычисляем яркость
            return (r * 299 + g * 587 + b * 114) / 1000 < 128;
        },
        getColor(val) {
            return this.itemsColor || this.getColorFromValue(val);
        },
        isNumber(e) {
            e = e || window.event;
            const ch = e.which || e.keyCode;
            if ((ch > 31 && (ch < 48 || ch > 57)) && ch !== 45 && ch !== 46) {
                e.preventDefault();
                return false;
            }
            return true;
        },
    }
};
</script>
<style scoped lang="scss">
    ::v-deep .add-new-value {
        display: flex;
        gap: 7px;
    }
    ::v-deep .v-chip {
        padding: 0 6px;
    }
    ::v-deep .v-list-item {
        min-height: 32px;
        .v-chip {
            min-width: 48px;
            display: inline-block;
            text-align: center;
        }
    }
    .v-select.v-select--chips.v-select--chips--small ::v-deep .v-select__selections {
        min-height: 32px;
    }
    .v-select ::v-deep .v-chip {
        padding: 0 6px;
        margin: 4px 4px 4px 0px;
    }
</style>
